import type { MeshLambertMaterial } from 'three'

/** Face-local bevels and panel joints stay attached to the model as it moves. */
export function detailSurfaces(material: MeshLambertMaterial): void {
  const previous = material.onBeforeCompile.bind(material)
  const key = material.customProgramCacheKey()
  material.onBeforeCompile = (shader, renderer) => {
    previous(shader, renderer)
    shader.vertexShader = shader.vertexShader
      .replace('#include <common>', '#include <common>\nattribute vec4 panel;\nvarying vec4 vPanel;')
      .replace('#include <begin_vertex>', '#include <begin_vertex>\nvPanel = panel;')
    shader.fragmentShader = shader.fragmentShader
      .replace('#include <common>', '#include <common>\nvarying vec4 vPanel;')
      .replace('#include <color_fragment>', `#include <color_fragment>
        if (min(vPanel.z, vPanel.w) > 0.065) {
          vec2 edge = min(vPanel.xy, vPanel.zw - vPanel.xy);
          vec2 aa = max(fwidth(vPanel.xy), vec2(0.001));
          vec2 bevel = 1.0 - smoothstep(vec2(0.012), vec2(0.012) + aa, edge);
          float lower = 1.0 - smoothstep(0.018, 0.018 + aa.y, vPanel.y);
          diffuseColor.rgb *= 1.0 + 0.14 * max(bevel.x, bevel.y) - 0.23 * lower;
          if (min(vPanel.z, vPanel.w) > 0.45) {
            vec2 cells = vPanel.xy / 0.28;
            vec2 seam = abs(fract(cells - 0.5) - 0.5) / max(fwidth(cells), vec2(0.001));
            float joint = 1.0 - smoothstep(0.0, 0.7, min(seam.x, seam.y));
            diffuseColor.rgb *= 1.0 - 0.085 * joint;
          }
        }`)
  }
  material.customProgramCacheKey = () => `${key}-voxel-surfaces`
}
